import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import { store } from './store';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/scss/custom.scss'
import JQuery from 'jquery'
window.$ = JQuery
import VirtualList from 'vue3-virtual-scroll-list';

const app = createApp(App);

app.use(router);
app.use(store);
app.component('virtual-list', VirtualList);
app.mount('#app');
